// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialProfile_container__ZrjfA","name":"SocialProfile_name__xVaZP","btn_disconnect":"SocialProfile_btn_disconnect__GnTr1"};